import { Expose, plainToClassFromExist, classToPlain } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { ISnLayoutAppbarConfig } from '../interfaces';
import { SnLayoutAppbarMode } from '../types';

export class SnLayoutAppbarConfig implements ISnLayoutAppbarConfig {
  @Expose()
  @Default('standart')
  public readonly mode: SnLayoutAppbarMode;

  @Expose()
  @Default(false)
  public readonly hidden: boolean;

  @Expose()
  @Default(false)
  public readonly hideNavButton: boolean;

  @Expose()
  @Default(false)
  public readonly search: boolean;

  @Expose()
  @Default(false)
  public readonly collapsible: boolean;

  constructor(private readonly _defaultConfig: ISnLayoutAppbarConfig = {}) {
    this.restore();
  }

  public restore(): void {
    plainToClassFromExist({ ...this._defaultConfig, mode: this.mode }, { strategy: 'excludeAll' });
  }

  public update(config: ISnLayoutAppbarConfig): void {
    const currentConfig = classToPlain(this);
    plainToClassFromExist(this, { ...currentConfig, ...config }, { strategy: 'excludeAll' });
  }
}
